export default {
	getSessionEventCollectionName(){
		let collectionName = null;
		if (localStorage) {
		 	if (localStorage.getItem("Session_Event_CollectionName")) {
			  collectionName = localStorage.getItem('Session_Event_CollectionName')
			}	      
	    }
	    return collectionName;
	},
	getSessionValueByKey(key)
	{
		let value = null;
		if (key && localStorage.getItem(key)) {
		  value = localStorage.getItem(key)
		}
		return value;
	},
	removeSessionValueByKey(key)
	{
		if (localStorage) 
		{
			localStorage.removeItem(key)
		}
	},
	checkLogin()
	{
		let returnVal = 0;
		if (localStorage) {
		 	if (localStorage.getItem('il')) {
			  returnVal = localStorage.getItem('il')
			}	      
	    }
	    return returnVal;
	},
	sessionLogOut(){
		localStorage.clear();
		document.cookie = "AT=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
	},
	setSessionUserInfo(obj)
	{		
		if(obj)
		{
			if (localStorage) {
				for (var key in obj) {
				    if (obj.hasOwnProperty(key)) {			        
						localStorage.setItem(key, obj[key])
				    }
				}
			}
		}
	}
}
